export function domReady(callback: Function): void {
    /**
     * The ready event handler and self cleanup method
     */
    const completed = () => {
        document.removeEventListener( "DOMContentLoaded", completed );
        window.removeEventListener( "load", completed );
        callback();
    }

    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE9-10 only
    // Older IE sometimes signals "interactive" too soon

    if ( document.readyState === "complete" ||
        ( document.readyState !== "loading" && !document.documentElement["doScroll"] ) ) {

        // Handle it asynchronously to allow scripts the opportunity to delay ready
        window.setTimeout(callback);
    } else {
        // Use the handy event callback
        document.addEventListener( "DOMContentLoaded", completed );

        // A fallback to window.onload, that will always work
        window.addEventListener( "load", completed );
    }
}
